import { useNavigate, useLocation } from 'react-router-dom';
import { useCallback } from 'react';

export const useNavigateWithParams = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateWithParams = useCallback((to: string, options?: any) => {
    const currentParams = new URLSearchParams(location.search);
    
    const newUrl = `${to}${currentParams.toString() ? `?${currentParams.toString()}` : ''}`;
    
    navigate(newUrl, options);
  }, [navigate, location.search]);

  return navigateWithParams;
};